module.exports = __webpack_public_path__ + "media/photo/telicom_banners_dy-e3fc40ad.jpg";